'use client';
import React from 'react';
import { DaySchedule, getActStatus } from '@/data/scheduleData';

interface DayTabsProps {
  schedule: DaySchedule[];
  activeDay: string;
  onSelectDay: (day: 'thu' | 'fri' | 'sat' | 'sun') => void;
  now: Date;
}

export default function DayTabs({ schedule, activeDay, onSelectDay, now }: DayTabsProps) {
  return (
    <div className="grid grid-cols-4 gap-1.5 bg-muted p-1.5 rounded-xl border border-border">
      {schedule.map((day) => {
        const isActive = day.dayKey === activeDay;
        const hasLive = day.acts.some(act => getActStatus(act, day.date, now) === 'live');

        return (
          <button
            key={`daytab-${day.dayKey}`}
            onClick={() => onSelectDay(day.dayKey)}
            className={`relative flex flex-col items-center py-2 px-1 rounded-lg text-center transition-all duration-200 ${
              isActive
                ? 'bg-primary text-primary-foreground shadow-sm'
                : 'text-muted-foreground hover:text-foreground hover:bg-card'
            }`}
          >
            {hasLive && (
              <span className="absolute top-1.5 right-1.5 w-1.5 h-1.5 rounded-full bg-red-500 animate-pulse" />
            )}
            <span className="font-display text-xs font-semibold tracking-wider">
              {day.shortLabel}
            </span>
            <span className="text-xs mt-0.5 opacity-75 hidden sm:block">
              {day.date.slice(0, 5)}
            </span>
            <span className="text-xs mt-0.5 opacity-60 hidden sm:block">
              {day.acts.length} Acts
            </span>
          </button>
        );
      })}
    </div>
  );
}